import { render, staticRenderFns } from "./HistoryVersion.vue?vue&type=template&id=39ead51e"
import script from "./HistoryVersion.vue?vue&type=script&lang=js"
export * from "./HistoryVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports